<template>
  <Groups
    can_expand
    :filter-empty-by="subGr => subGr.count || !active_infinity"
    filter_empty
    :groups="lotGroups"
    :small="true"
    :with_title="true">
    <template #title="{ group, index: groupIndex }">
      <LotGroupTitle
        :data-qa="`item-${groupIndex}-name`"
        :description="group.description"
        :title="`#${groupIndex + 1} ${group.title}`"/>
    </template>
    <template #after="{ group, index: groupIndex }">
      <div
        v-if="group.totalPrice"
        class="pr-6"> 
        <KeyValue
          :caption="$t('Tenders.TotalPrice')"
          :data-qa="`item-${groupIndex}-total-price`"
          :value="`${$n(group.totalPrice)} ${tender.currency.title}`"/>
      </div>
    </template>
    <template #content="{ group: subGroup }">
      <div>
        <LotsTableBase
          :active_infinity="active_infinity"
          :additional_fields="additional_fields"
          :bidding_type="bidding_type"
          class="mb-3"
          :custom-sort-slice="customSortSlice"
          :disable-open-offers-for-lot="disableOpenOffersForLot"
          :group="subGroup"
          :in_creating="in_creating"
          :lots_headers="lots_headers"
          :tender="tender"/>
        <sDivider
          class="mb-4"
          color="var(--secondary__green_not_active)"/>
      </div>
    </template>
  </Groups>
</template>

<script>
import Groups from 'components/common/blocks/groups/Groups.vue'
import LotGroupTitle from 'components/tenders/tender page/tender tabs/tables/LotGroupTitle.vue'
import LotsTableBase from 'components/tenders/tender page/tender tabs/tables/LotsTableBase.vue'
import lotsTableMixin from 'mixins/lotsTableMixin.js'

export default {
  name: 'LotsTabGroupTable',
  mixins: [lotsTableMixin],
  components: {
    Groups,
    LotGroupTitle,
    LotsTableBase
  },
  computed: {
    lotGroups() {
      return this.group.subGroups?.map(group => {
        const totalPrice = group.items?.reduce((acc, lot) => acc + ((lot.quantity * lot.initialAmount) || 0), 0)
        return {
          ...group,
          totalPrice
        }
      }) ?? []
    }
  },
  props: {
    active_infinity: {
      type: Boolean,
      default: false
    }
  }
}
</script>